import { defineComponent as _defineComponent } from 'vue'
import { PaymentMethodInfo } from '@/services/billing-utils';
import { PropType, computed } from 'vue';
import { PaymentMethod as BillingPaymentMethod } from '@/api/api-billing';
import store from '@/store/store';
import { performAction } from '@/services/vue-utils';
import i18n from '@/plugins/i18n';
import PaymentMethodLayout from './PaymentMethodLayout.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'PaymentMethodSepaDebit',
  props: {
  value: { type: String as PropType<string>, required: true },
  active: { type: Boolean as PropType<boolean>, default: false },
  paymentMethodInfo: { type: Object as PropType<PaymentMethodInfo>, required: true },
  showControls: { type: Boolean, required: false, default: false },
},
  emits: ['method:delete', 'method:set-default'],
  setup(__props, { emit }) {

const props = __props;





const sepaDebitInfo = computed(() => props.paymentMethodInfo.sepaDebitInfo);

const showPaymentMethodMandate = async () => {
  const pm = props.paymentMethodInfo.paymentMethod;
  const paymentMethodID = pm.ID;
  let paymentMethod = undefined as BillingPaymentMethod|undefined;
  const action = async () => {
    paymentMethod = await store.dispatch('billingGetPaymentMethod', { paymentMethodID });
  };
  const ok = await performAction(null, i18n.tc('error.load_data'), action);
  if (!ok || !paymentMethod?.mandate?.url) return;

  const newWin = window.open(
    paymentMethod?.mandate?.url,
    'invoiceWindow',
    'height=600,width=600',
  );
  newWin!.document.close();
  newWin!.focus();
};


return { __sfc: true,emit, props, sepaDebitInfo, showPaymentMethodMandate, PaymentMethodLayout }
}

})